'use client';

import { Box } from '@mantine/core';

const HEIGHTS = { sm: 8, md: 12, lg: 16, xl: 20 };

// Progress bar styled as a LEGO brick seen from above: a row of stud segments
// (like a 1x10 plate). Each segment fills left-to-right; a translucent stud
// pops in once its segment is complete. Turns green at 100%.
export function BrickProgress({ value = 0, size = 'md', studs = 10, style, 'aria-label': ariaLabel }) {
  const pct = Math.max(0, Math.min(100, value));
  const done = pct >= 100;
  const height = HEIGHTS[size] || HEIGHTS.md;

  return (
    <Box
      role="progressbar"
      aria-valuenow={Math.round(pct)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={ariaLabel || 'Progress'}
      className={`brick-progress${done ? ' brick-progress-done' : ''}`}
      style={{ height, ...style }}
    >
      {Array.from({ length: studs }).map((_, i) => {
        const cellStart = (i / studs) * 100;
        const cellEnd = ((i + 1) / studs) * 100;
        const fillRatio = Math.max(0, Math.min(1, (pct - cellStart) / (cellEnd - cellStart)));
        return (
          <span key={i} className="brick-progress-cell">
            <span className="brick-progress-fill" style={{ width: `${fillRatio * 100}%` }} />
            {fillRatio >= 1 && <span className="brick-progress-stud" />}
          </span>
        );
      })}
    </Box>
  );
}
